import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core'

/**
 * Brand-consistent confirmation dialog. Matches the visual treatment of
 * the modify-admission modal (CANCEL / SUBMIT pattern) so connectivity
 * popups, "empty cart" prompts, etc. don't look like default SweetAlert2.
 *
 * Rendered imperatively via the `confirm()` / `confirmDialog()` helpers
 * in `app/helpers.js` — callers don't mount it directly.
 */
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    maxWidth='xs'
    fullWidth
    aria-labelledby='oh-confirm-dialog-title'
  >
    {title ? (
      <DialogTitle id='oh-confirm-dialog-title'>{title}</DialogTitle>
    ) : null}
    <DialogContent>
      <Typography variant='body1' style={{ whiteSpace: 'pre-line' }}>
        {message}
      </Typography>
    </DialogContent>
    <DialogActions style={{ padding: '12px 24px 20px' }}>
      <Button onClick={onCancel} color='default'>
        {cancelText || 'Cancel'}
      </Button>
      <Button
        onClick={onConfirm}
        color='primary'
        variant='contained'
        autoFocus
      >
        {confirmText || 'Yes'}
      </Button>
    </DialogActions>
  </Dialog>
)

export default ConfirmDialog
